import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {Ofwca} from '../../../shared/interface/ofwca';
import {MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {
  COMPANY_ASF,
  COMPANY_ASF_PREMIUM,
  CONTRACT_STATUS_ACTIVE,
  CONTRACT_TYPE_FRANCHISE,
  CONTRACT_TYPE_PROFIT,
  DICT_TYPE_DOUBLE_REGISTRATION,
  DICT_TYPE_WHAT_IS_NEEDED,
  DictService,
  DOUBLE_REGISTRATION_NONE,
  DYNAMIC_DICTIONARY_COMPENSA_OFFICE,
  DYNAMIC_DICTIONARY_COMPENSA_OFFICE_PROFIT,
  DYNAMIC_DICTIONARY_MANAGER_WIENER,
  REGISTRATION_WHAT_IS_NEEDED_EXAM_AND_REGISTRATION,
  SALES_COMPENSA,
  SALES_COMPENSA_WIENER,
} from '../../../shared/services/dict.service';
import {delay, first, takeUntil} from 'rxjs/operators';
import {Uuid} from '../../../shared/interface/response/uuid';
import {HttpErrorResponse} from '@angular/common/http';
import {RegistrationAddDialogComponent} from '../registration-add-dialog/registration-add-dialog.component';
import {RegistrationService} from '../../../shared/services/registration.service';
import {Contract} from '../../../shared/interface/contract';
import {OfwcaRegistrationInfo} from '../../../shared/interface/ofwca-registration-info';
import {InsuranceCompany} from '../../../shared/interface/insurance-company';
import {validNip} from '../../../shared/validator/nip-validator';
import {
  IC_COMPENSA, IC_COMPENSA_LIFE, IC_ERGO_HESTIA, IC_ERGO_HESTIA_LIFE, IC_EUROP_ASSISTANCE,
  IC_EUROPA, IC_GENERALI, IC_GENERALI_LIFE,
  IC_LINK4,
  IC_PZU, IC_PZU_LIFE, IC_SIGNAL_IDUNA, IC_SIGNAL_IDUNA_LIFE, IC_TRASTI,
  IC_WIENER
} from '../../../shared/services/insurance-company.service';
import {Dictionary} from "../../../shared/interface/dictionary";
import {OfwcaService} from "../../../shared/services/ofwca.service";
import {ContractService} from "../../../shared/services/contract.service";
import {validPhoneNumber} from "../../../shared/validator/phone-validator";



@Component({
  selector: 'app-registrations-add-multiple',
  templateUrl: './registrations-add-multiple.component.html',
  styleUrls: ['./registrations-add-multiple.component.scss']
})
export class RegistrationsAddMultipleComponent implements OnInit, OnDestroy  {
  @Input() ofwcaObject?: Ofwca;
  @Input() contractObject?: Contract;
  @Input() dialogRef?: MatDialogRef<RegistrationAddDialogComponent>;
  @Output() closeModification = new EventEmitter<any>();
  @Output() registrationCreated = new EventEmitter<string>();

  readonly COMPANY_ASF = COMPANY_ASF;
  readonly CONTRACT_TYPE_PROFIT = CONTRACT_TYPE_PROFIT;
  readonly  DYNAMIC_DICTIONARY_MANAGER_WIENER = DYNAMIC_DICTIONARY_MANAGER_WIENER;
  readonly DYNAMIC_DICTIONARY_COMPENSA_OFFICE = DYNAMIC_DICTIONARY_COMPENSA_OFFICE;
  readonly DYNAMIC_DICTIONARY_COMPENSA_OFFICE_PROFIT = DYNAMIC_DICTIONARY_COMPENSA_OFFICE_PROFIT;

  registrationForm: FormGroup;
  ofwcaControl: FormControl;
  contractControl: FormControl;
  insuranceCompanyControl: FormControl;
  whatIsNeededControl: FormControl;
  doubleRegistrationControl: FormControl;
  salesProfilesControlEH: FormControl;
  salesProfilesControlEHL: FormControl;
  salesProfilesControlG: FormControl;
  salesProfilesControlGL: FormControl;
  salesProfilesControlCo: FormControl;
  registrationCompensaOfficeNewControl: FormControl;
  chronieLoginControl: FormControl;
  registrationFacilityAddressGroup: FormGroup;
  registrationSegmentControl: FormControl;
  registrationFacilityAddressPzuGroup: FormGroup;
  selectedContract?: Contract;
  selectedInsuranceCompany?: InsuranceCompany;
  contractCompanyId: ReplaySubject<number> = new ReplaySubject<number>(1);
  showAllContracts = false;
  ofwcaRegistrationInfo?: OfwcaRegistrationInfo;
  ofwcaContracts: ReplaySubject<Contract[]> = new ReplaySubject<Contract[]>(1);
  processingRequest = false;
  errors: any = {};
  availableSalesProfiles = false;
  registrationFormValid = false;
  salesProfilesDictTypeSubjectEH: ReplaySubject<string> = new ReplaySubject<string>(1);
  salesProfilesDictTypeSubjectEHL: ReplaySubject<string> = new ReplaySubject<string>(1);
  salesProfilesDictTypeSubjectG: ReplaySubject<string> = new ReplaySubject<string>(1);
  salesProfilesDictTypeSubjectGL: ReplaySubject<string> = new ReplaySubject<string>(1);
  salesProfilesDictTypeSubjectCo: ReplaySubject<string> = new ReplaySubject<string>(1);
  requireLink4Data = false;
  requirePzuData = false;
  requirePzuLife = false;
  selectedOfwca?: Ofwca;
  requireCompensaData = false;
  chronieInsuranceCompanies = false;
  selectedInsuranceCompanies: InsuranceCompany[] = [];
  insuranceCompanyKey = [];
  // requireTrasti = false;
  registrationCompensaLifeOfficeControl: FormControl;
  requireCompensaLifeData = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private registrationService: RegistrationService,
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private dictService: DictService,
    private snack: MatSnackBar,
    private ofwcaService: OfwcaService,
    private contractService: ContractService,
  ) {
    this.registrationForm = this.fb.group({
      ofwca: this.ofwcaControl = fb.control('', [Validators.required]),
      contract: this.contractControl = fb.control('', [Validators.required]),
      showAllContracts: fb.control(false),
      insuranceCompany: this.insuranceCompanyControl = fb.control([], [Validators.required]),
      whatIsNeeded: this.whatIsNeededControl = fb.control('', [Validators.required]),
      doubleRegistration: this.doubleRegistrationControl = fb.control('', [Validators.required]),
      salesProfilesEH: this.salesProfilesControlEH = fb.control([], [Validators.required]),
      salesProfilesEHL: this.salesProfilesControlEHL = fb.control([], [Validators.required]),
      salesProfilesG: this.salesProfilesControlG = fb.control([], [Validators.required]),
      salesProfilesGL: this.salesProfilesControlGL = fb.control([], [Validators.required]),
      salesProfilesCo: this.salesProfilesControlCo = fb.control([], [Validators.required]),
      registrationNipLink4: fb.control('', [validNip(), Validators.required]),
      registrationNipPzu: fb.control('', [validNip(), Validators.required]),
      registrationFacilityAddress: this.registrationFacilityAddressGroup = this.formHelper.generateAddressFormGroup(),
      registrationOfwcaOwner: fb.control('', [Validators.required]),
      registrationCompanyName: fb.control('', [Validators.required]),
      registrationPartnerEmail: fb.control('', [Validators.required, Validators.email]),
      registrationCompensaOfficeNew: this.registrationCompensaOfficeNewControl = fb.control('', [Validators.required]),
      chronieLogin: this.chronieLoginControl = fb.control('', [Validators.email, Validators.required]),
      registrationSegment: this.registrationSegmentControl = fb.control('', [Validators.required]),
      registrationAgencyName: fb.control('', [Validators.required]),
      registrationFacilityAddressPzu: this.registrationFacilityAddressPzuGroup = this.formHelper.generateAddressFormGroup(true,true ,true),
      // trastiEmail:  fb.control('', [Validators.email, Validators.required]),
      registrationCompensaLifeOffice: this.registrationCompensaLifeOfficeControl = fb.control('', [Validators.required]),
      additionalEmail: fb.control('', [Validators.email]),
      additionalPhone: fb.control('', [validPhoneNumber()]),
    });

    this.chronieLoginControl.disable();
    this.doubleRegistrationControl.disable();
    this.whatIsNeededControl.disable();

  }

  ngOnInit(): void {
    this.registrationForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.registrationFormValid = this.registrationForm.valid);

    this.registrationForm.get('showAllContracts').valueChanges
      .pipe(takeUntil(this.destroyed$))
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: boolean) => this.showAllContracts = val);

    this.contractControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((contractId: string) => {
        this.insuranceCompanyControl.reset();
        this.insuranceCompanyChanged([]);
      });


    this.ofwcaControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((ofwcaId: string) => {
        this.registrationService.getOfwcaRegistrationInfo(ofwcaId)
          .subscribe((ofwcaRegistrationInfo: OfwcaRegistrationInfo) => {
            const availableContracts = ofwcaRegistrationInfo.contracts.filter((contract: Contract) =>
              ![CONTRACT_TYPE_FRANCHISE].includes(contract.type?.key) );
            if (!this.contractObject) {
              this.ofwcaContracts.next(availableContracts);

              let activeContract = null;
              let activeAsfPremiumContract = null;
              let asfPremiumContract = null;
              ofwcaRegistrationInfo.contracts.forEach((contract: Contract) => {
                if (contract.company?.key === COMPANY_ASF_PREMIUM) {
                  asfPremiumContract = contract;

                  if (contract.status?.key === CONTRACT_STATUS_ACTIVE) {
                    activeAsfPremiumContract = contract;
                  }
                }

                if (contract.status?.key === CONTRACT_STATUS_ACTIVE) {
                  activeContract = contract;
                }
              });

              if (null !== activeAsfPremiumContract) {
                this.contractControl.setValue(activeAsfPremiumContract.uuid);
                this.contractChanged(activeAsfPremiumContract);
              } else if (null !== activeContract) {
                this.contractControl.setValue(activeContract.uuid);
                this.contractChanged(activeContract);
              } else if (null !== asfPremiumContract) {
                this.contractControl.setValue(asfPremiumContract.uuid);
                this.contractChanged(asfPremiumContract);
              }
            }
            this.ofwcaRegistrationInfo = ofwcaRegistrationInfo;
            if (this.ofwcaRegistrationInfo.facilityAddress || this.ofwcaRegistrationInfo.agencyName || this.ofwcaRegistrationInfo.nip) {
              this.formHelper.setAddress(this.ofwcaRegistrationInfo?.facilityAddress, this.registrationFacilityAddressPzuGroup);
              this.registrationForm.get('registrationNipPzu').setValue(this.ofwcaRegistrationInfo?.nip);
              this.registrationForm.get('registrationAgencyName').setValue(this.ofwcaRegistrationInfo?.agencyName);
            }
          });
        this.updateMode();
      });

    if (this.contractObject) {
      this.contractControl.setValue(this.contractObject.uuid);
      this.contractChanged(this.contractObject);
    }

    if (this.ofwcaObject) {
      this.ofwcaControl.setValue(this.ofwcaObject.uuid);
      this.ofwcaChanged(this.ofwcaObject);
    }

    this.dictService.getId(DOUBLE_REGISTRATION_NONE, DICT_TYPE_DOUBLE_REGISTRATION)
      .subscribe((dictId: number) => this.doubleRegistrationControl.setValue(dictId));

    this.dictService.getId(REGISTRATION_WHAT_IS_NEEDED_EXAM_AND_REGISTRATION, DICT_TYPE_WHAT_IS_NEEDED)
      .subscribe((dictId: number) => this.whatIsNeededControl.setValue(dictId));
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  contractChanged(contract: Contract): void {
    this.insuranceCompanyControl.reset();
    this.contractCompanyId.next(contract.company.id);
    this.selectedContract = contract;
  }

  ofwcaChanged(ofwca: Ofwca): void {
    this.selectedOfwca = ofwca;
    this.updateChronieForm();
  }

  save(): void {
    this.registrationService.sendMultipleForm(this.registrationForm.getRawValue())
      .subscribe({
        next: () => {
          this.processingRequest = false;
          this.snack.open('Pomyślnie utworzono rejestrację', '', {duration: 2000});
          this.closeModification.emit(true);
          if (this.dialogRef) {
            this.registrationCreated.emit();
            this.dialogRef.close();
          } else {
            this.router.navigate(['/ofwca/szczegoly', this.ofwcaControl.value.toString()]);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.processingRequest = false;
          if (error.error.error.list.insuranceCompany) {
            this.snackBar.open(' '
              + error.error.error.list.insuranceCompany.toString() , error.status.toString(), {
              duration: 8000,
              panelClass: ['success-snackbar']
          });
          } else {
            this.snackBar.open( 'Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
              duration: 2000,
            });
          }

          if (error.status === 400) {
            this.errors = error.error.error.list;
            this.formHelper.setBackendErrorState(this.registrationForm, this.errors);
          }
        }
      });

  }

  cancel(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      this.router.navigate(['/rejestracje']);
    }
  }

  insuranceCompanyChanged(insuranceCompanies: InsuranceCompany[]): void {
    this.insuranceCompanyKey = [];
    insuranceCompanies.forEach((insuranceCompany: InsuranceCompany) => {
      this.insuranceCompanyKey.push(insuranceCompany.key);
    });
    this.updateMode();
  }
  updateMode(): void{
    this.updateChronieForm();
    this.updateSalesProfiles();
    if (this.insuranceCompanyKey.indexOf(IC_COMPENSA) !== -1) {
      this.requireCompensaData = true;
      this.registrationCompensaOfficeNewControl.enable();
    } else {
      this.requireCompensaData = false;
      this.registrationCompensaOfficeNewControl.disable();
    }

    if (this.insuranceCompanyKey.indexOf(IC_COMPENSA_LIFE) !== -1) {
      // this.requireCompensaLifeData = true;
      // this.registrationCompensaLifeOfficeControl.enable();
    } else {
      this.requireCompensaLifeData = false;
      this.registrationCompensaLifeOfficeControl.disable();
    }
    if (this.insuranceCompanyKey.indexOf(IC_LINK4) !== -1  ||
      this.insuranceCompanyKey.indexOf(IC_PZU) !== -1  ||
      this.insuranceCompanyKey.indexOf(IC_PZU_LIFE) !== -1   ) {
      this.registrationForm.get('additionalEmail').enable();
      this.registrationForm.get('additionalPhone').enable();
    }else{
      this.registrationForm.get('additionalEmail').enable();
      this.registrationForm.get('additionalPhone').enable();
    }

    if (this.insuranceCompanyKey.indexOf(IC_PZU_LIFE) !== -1   ) {
      this.requirePzuLife = true;
    }else{
      this.requirePzuLife = false;
    }

    if (this.insuranceCompanyKey.indexOf(IC_LINK4) !== -1) {
      this.requireLink4Data = true;
      this.registrationForm.get('registrationNipLink4').enable();
      this.registrationForm.get('registrationOfwcaOwner').enable();
      this.registrationForm.get('registrationCompanyName').enable();
      this.registrationForm.get('registrationPartnerEmail').enable();
      this.registrationForm.get('registrationFacilityAddress').enable();
      this.registrationForm.get('registrationNipLink4').setValue(this.selectedOfwca?.partner?.nip);
      this.registrationForm.get('registrationOfwcaOwner').setValue(this.selectedContract?.partner?.owner?.fullName);
      this.registrationForm.get('registrationCompanyName').setValue(this.selectedContract?.partner?.fullName);
      this.registrationForm.get('registrationPartnerEmail').setValue(this.selectedContract?.partner?.mainEmails[0]?.address);
      if (this.selectedOfwca?.facility?.address){
        this.formHelper.setAddress(this.selectedOfwca.facility.address, this.registrationFacilityAddressGroup);
      }
    }else {
      this.requireLink4Data = false;
      this.registrationForm.get('registrationNipLink4').disable();
      this.registrationForm.get('registrationOfwcaOwner').disable();
      this.registrationForm.get('registrationCompanyName').disable();
      this.registrationForm.get('registrationPartnerEmail').disable();
      this.registrationForm.get('registrationFacilityAddress').disable();
    }

    if (this.insuranceCompanyKey.indexOf(IC_PZU) !== -1 || this.insuranceCompanyKey.indexOf(IC_PZU_LIFE) !== -1 ) {
        this.requirePzuData = true;
        this.registrationForm.get('registrationNipPzu').enable();
        this.registrationForm.get('registrationAgencyName').enable();
        this.registrationForm.get('registrationFacilityAddressPzu').enable();
      } else if (this.insuranceCompanyKey.indexOf(IC_PZU) === -1 && this.insuranceCompanyKey.indexOf(IC_PZU_LIFE) === -1) {
      this.requirePzuData = false;
      this.registrationForm.get('registrationNipPzu').disable();
      this.registrationForm.get('registrationAgencyName').disable();
      this.registrationForm.get('registrationSegment').disable();
      this.registrationForm.get('registrationFacilityAddressPzu').disable();
    }
    // if (this.insuranceCompanyKey.indexOf(IC_TRASTI) !== -1 ){
    //   this.requireTrasti = true;
    //   this.registrationForm.get('trastiEmail').enable();
    //   this.registrationForm.get('trastiEmail').setValue(this?.selectedOfwca?.email);
    // } else {
    //   this.requireTrasti = false;
    //   this.registrationForm.get('trastiEmail').disable();
    //   this.registrationForm.get('trastiEmail').reset();
    // }
  }

  updateChronieForm(): void {
    this.chronieInsuranceCompanies = false;
    if ( (this.insuranceCompanyKey.indexOf(IC_WIENER) !== -1 || this.insuranceCompanyKey.indexOf(IC_EUROPA) !== -1)) {
      // this.chronieLoginControl.enable();
      // this.chronieInsuranceCompanies = true;
      // if (!this.chronieLoginControl.value) {
      //   this.chronieLoginControl.setValue(this?.selectedOfwca?.email);
      // }
    } else {
      this.chronieLoginControl.disable();
    }
  }
  updateSalesProfiles(): void {
    this.availableSalesProfiles = false;
    if (this.insuranceCompanyKey.indexOf(IC_ERGO_HESTIA) !== -1 ) {
      this.dictService.getDictSubject()
        .pipe(first())
        .subscribe((items: Dictionary[]) => {
          items.forEach((dict: Dictionary) => {
            if (dict.type === 'sales_' + IC_ERGO_HESTIA) {
              this.availableSalesProfiles = true;
            }
          });
        });
      this.registrationForm.get('salesProfilesEH').enable();
      this.salesProfilesDictTypeSubjectEH.next('sales_' + IC_ERGO_HESTIA);
    } else {
      this.registrationForm.get('salesProfilesEH').disable();
    }
    if (this.insuranceCompanyKey.indexOf(IC_ERGO_HESTIA_LIFE) !== -1 ) {
      this.dictService.getDictSubject()
        .pipe(first())
        .subscribe((items: Dictionary[]) => {
          items.forEach((dict: Dictionary) => {
            if (dict.type === 'sales_' + IC_ERGO_HESTIA_LIFE) {
              this.availableSalesProfiles = true;
            }
          });
        });
        this.registrationForm.get('salesProfilesEHL').enable();
        this.salesProfilesDictTypeSubjectEHL.next('sales_' + IC_ERGO_HESTIA_LIFE);
      } else {
        this.registrationForm.get('salesProfilesEHL').disable();
    }
    if (this.insuranceCompanyKey.indexOf(IC_GENERALI) !== -1 ) {
      this.dictService.getDictSubject()
        .pipe(first())
        .subscribe((items: Dictionary[]) => {
          items.forEach((dict: Dictionary) => {
            if (dict.type === 'sales_' + IC_GENERALI) {
              this.availableSalesProfiles = true;
            }
          });
        });
      this.registrationForm.get('salesProfilesG').enable();
      this.salesProfilesDictTypeSubjectG.next('sales_' + IC_GENERALI);
    } else {
      this.registrationForm.get('salesProfilesG').disable();
    }
    if (this.insuranceCompanyKey.indexOf(IC_GENERALI_LIFE) !== -1 ) {
      this.dictService.getDictSubject()
        .pipe(first())
        .subscribe((items: Dictionary[]) => {
          items.forEach((dict: Dictionary) => {
            if (dict.type === 'sales_' + IC_GENERALI_LIFE) {
              this.availableSalesProfiles = true;
            }
          });
        });

        this.registrationForm.get('salesProfilesGL').enable();
        this.salesProfilesDictTypeSubjectGL.next('sales_' + IC_GENERALI_LIFE);
      } else {
        this.registrationForm.get('salesProfilesGL').disable();
    }
    // if (this.insuranceCompanyKey.indexOf(IC_COMPENSA) !== -1 ) {
    //   this.dictService.getDictSubject()
    //     .pipe(first())
    //     .subscribe((items: Dictionary[]) => {
    //       items.forEach((dict: Dictionary) => {
    //         if (dict.type === 'sales_' + IC_COMPENSA) {
    //           this.availableSalesProfiles = true;
    //         }
    //       });
    //     });
    //
    //   this.registrationForm.get('salesProfilesCo').enable();
    //   this.salesProfilesDictTypeSubjectCo.next('sales_' + IC_COMPENSA);
    // } else {
      this.registrationForm.get('salesProfilesCo').disable();
    // }
  }

  downloadPartner(): void{
    if (!this.ofwcaObject) {
      this.ofwcaService.get(this.ofwcaControl.value)
        .subscribe((ofwca: Ofwca) => {
          // console.log(ofwca.facility.address);
          this.formHelper.setAddress(ofwca.facility.address, this.registrationFacilityAddressPzuGroup);
        });
    }else {
      // console.log(this.ofwcaObject.facility.address);
      this.formHelper.setAddress(this.ofwcaObject.facility.address, this.registrationFacilityAddressPzuGroup);
    }
    if (!this.contractObject) {
      this.contractService.get(this.contractControl.value).subscribe((contract: Contract) => {
        this.registrationForm.get('registrationNipPzu').setValue(contract?.partner?.nip);
        this.registrationForm.get('registrationAgencyName').setValue(contract?.partner?.fullName);
      });
    }else {
      this.registrationForm.get('registrationNipPzu').setValue(this.contractObject?.partner?.nip);
      this.registrationForm.get('registrationAgencyName').setValue(this.contractObject?.partner?.fullName);
    }

  }

}
